import { FunctionComponent, Ref } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, tabletCSS } from '@measures/responsive'
import CollapsibleScoreboardContext from '@contexts/collapsibleScoreboardContext'
import ScoreboardContext from '@contexts/scoreboard'
import useSportsEvent from '@hooks/useSportsEvent'

import CollapsibleSoccerScoreboard from './CollapsibleSoccerScoreboard'
import ScoreboardMainSection from './ScoreboardMainSection'

type CollapsibleScoreboardProps = {
  ref?: Ref<HTMLDivElement | null>
  typeOfSport: 'soccer'
  matchId: string
  shouldShowCollapsibleScoreboard: boolean
}

const StyledCollapsibleScoreboard = styled.div<
  Pick<CollapsibleScoreboardProps, 'shouldShowCollapsibleScoreboard'>
>`
  ${({
    theme: {
      colors: { fillWeak },
      measures: { stretchWidthOnMobile },
    },
    shouldShowCollapsibleScoreboard,
  }) => {
    return css`
      background-color: ${fillWeak};
      height: 48px;
      position: sticky;
      top: 48px;
      right: 16px;
      z-index: ${shouldShowCollapsibleScoreboard ? 1 : -1};
      display: flex;
      justify-content: center;
      ${stretchWidthOnMobile()};
      opacity: ${shouldShowCollapsibleScoreboard ? 1 : 0};
      transition: opacity 0.2s ease-in-out;
      ${desktopCSS(css`
        display: none;
      `)}
      ${tabletCSS(css`
        display: none;
      `)}
    `
  }}
`

const CollapsibleScoreboard: FunctionComponent<CollapsibleScoreboardProps> = ({
  matchId,
  typeOfSport,
  shouldShowCollapsibleScoreboard,
  ref,
}) => {
  const { data } = useSportsEvent({ typeOfSport, matchId })

  if (!data) {
    return null
  }

  return (
    <ScoreboardContext.Provider value={data}>
      <CollapsibleScoreboardContext.Provider value={true}>
        <StyledCollapsibleScoreboard
          ref={ref}
          shouldShowCollapsibleScoreboard={shouldShowCollapsibleScoreboard}
        >
          <ScoreboardMainSection>
            <CollapsibleSoccerScoreboard />
          </ScoreboardMainSection>
        </StyledCollapsibleScoreboard>
      </CollapsibleScoreboardContext.Provider>
    </ScoreboardContext.Provider>
  )
}

export default CollapsibleScoreboard
